/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_History_Type_OutInputs */

const vi_sl_lot_history_type_out = /** @type {(inputs: Sl_Lot_History_Type_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất`)
};

/**

* @param {Sl_Lot_History_Type_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_history_type_out = /** @type {((inputs?: Sl_Lot_History_Type_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_History_Type_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_history_type_out(inputs)
});